<template>
  <section
    class="product-details justify-content-between p-4 mt-md-5 mt-4 pb-3 mb-3"
  >
    <Galleries
      v-if="product != null"
      :sets="sets"
      :video="product.video"
      :cover="product.video_cover"
      :selectedVariety="selectedVarietyForGallery"
      :galleries="galleries"
    />
    <section
      class="product-details-content position-relative d-flex flex-column pr-3 pl-3 pr-sm-4 pl-sm-2"
      style="padding-top: 2rem"
    >
      <div class="product-details-title d-flex justify-content-between pb-2">
        <div v-if="product != null" class="text-right ml-3">
          <h5
            class="fontsize-heavy weight-bold font-900 text-color-444 text-justify"
          >
            {{ product.title }}
          </h5>
          <h6 class="fontsize-small text-color-999 text-justify">
            {{ product.brand ? product.brand.name + "/" : "" }}
            <template v-if="product.categories != ''"> </template>
            <span v-for="(cat, index) in product.categories" :key="cat.id">
              {{ cat.title }}
              {{ index != product.categories.length - 1 ? "،" : "" }}
            </span>
          </h6>
        </div>
        <div v-else class="text-right ml-3" style="width: 200px">
          <b-skeleton width="100%" />
          <b-skeleton width="100%" />
        </div>
        <div class="product-details-share mt-2 flex-shrink-0 d-md-block d-none">
          <ProductFavorite :productId="product ? product.id : null" />
          <ProductShare :product="product" />
        </div>
      </div>
      <div class="d-flex justify-content-between pb-2">
        <div v-if="product != null" class="text-right price wrapMobile">
          <!-- <template v-if="product.status === 'soon'">
            <div class="font-weight-bold text-info mt-2">بزودی</div>
          </template> -->
          <template>
            <div
              class="text-color-999 pt-3"
              :class="
                (prices.discount_price ? 'fontsize-medium' : 'fontsize-large') +
                ' ' +
                (prices.discount_price ? 'line-through' : '')
              "
            >
              <span :class="!prices.discount_price ? 'text-red' : ''">{{
                prices.price | price
              }}</span
              ><span class="mr-1">تومان</span>
            </div>
            <div
              v-if="prices.discount_price"
              class="mt-2"
              style="transform: translateY(5px)"
            >
              <span class="text-color-themeRed weight-bold fontsize-heavy">{{
                prices.final_price | price
              }}</span
              ><span class="text-color-666 fontsize-medium mr-1">تومان</span>
            </div>

            <div
              v-if="product && product.discount_until"
              id="productDiscountCountdown"
            >
              <flip-countdown
                :labels="labels"
                countdownSize="24px"
                labelSize="16px"
                :deadline="discount_until"
              ></flip-countdown>
            </div>
          </template>
          <!-- <template v-else>
            <div class="font-weight-bold text-danger mt-2">ناموجود</div>
            <div v-if="product.chargeable">
              <button
                @click="listenRequest"
                :disabled="listenDisabled"
                v-if="!hasInListens"
                class="btn btn-danger mt-2"
              >
                <svg
                  width="16"
                  height="16"
                  version="1.1"
                  fill="#fff"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 116.11 122.88"
                  style="
                    margin-left: 3px;
                    enable-background: new 0 0 116.11 122.88;
                  "
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M74.82,109.04c-0.37,1.94-1.02,3.72-1.96,5.35c-0.97,1.67-2.24,3.18-3.8,4.5c-1.57,1.32-3.27,2.32-5.12,2.99 c-1.85,0.67-3.81,1-5.88,1c-2.08,0-4.04-0.34-5.88-1c-1.84-0.67-3.55-1.66-5.11-2.99c-1.57-1.33-2.83-2.83-3.8-4.5 c-0.97-1.67-1.63-3.51-1.99-5.53c-0.18-0.98,0.48-1.92,1.46-2.1c0.03,0,0.32-0.03,0.32-0.03h30.02c1,0,1.82,0.81,1.82,1.82 C74.89,108.72,74.86,108.88,74.82,109.04L74.82,109.04L74.82,109.04z M20.21,0.25c1.83-0.73,3.9,0.17,4.63,2 c0.73,1.83-0.17,3.9-2,4.63c-3.96,1.58-7.28,3.77-9.93,6.61c-2.64,2.84-4.63,6.36-5.93,10.59c-0.58,1.88-2.58,2.94-4.46,2.36 c-1.88-0.58-2.94-2.58-2.36-4.46c1.63-5.3,4.15-9.74,7.52-13.36C11.05,5.01,15.24,2.23,20.21,0.25L20.21,0.25z M93.27,6.88 c-1.83-0.73-2.73-2.8-2-4.63c0.73-1.83,2.8-2.73,4.63-2c4.97,1.98,9.16,4.76,12.53,8.38c3.37,3.63,5.9,8.07,7.52,13.36 c0.58,1.88-0.48,3.88-2.36,4.46c-1.88,0.58-3.88-0.48-4.46-2.36c-1.3-4.24-3.29-7.76-5.93-10.59 C100.55,10.65,97.23,8.46,93.27,6.88L93.27,6.88z M71.91,11.94c2.04,0.81,4,1.78,5.88,2.91c0.07,0.05,0.15,0.09,0.22,0.14 c1.8,1.11,3.48,2.33,5.02,3.65c3.29,2.83,6.03,6.15,8.2,9.91c1.08,1.88,2.01,3.84,2.78,5.86l0,0c0.79,2.09,1.38,4.22,1.78,6.41 c0.39,2.2,0.59,4.45,0.59,6.76c0,4.56,0,7.03,0,7.33c0.01,2.34,0.02,4.63,0.04,6.86v0.02l0,0c0.01,2.02,0.14,4.05,0.39,6.08 c0.25,2.01,0.61,3.95,1.08,5.82l0,0c0.47,1.84,1.11,3.62,1.9,5.32c0.82,1.75,1.82,3.47,2.99,5.14l0.01,0 c1.16,1.64,2.61,3.27,4.35,4.87c1.8,1.65,3.88,3.28,6.26,4.86c1.36,0.91,1.73,2.76,0.81,4.12c-0.57,0.85-1.51,1.32-2.47,1.32v0.01 l-26.85,0H58.06H31.21H4.37c-1.65,0-2.98-1.33-2.98-2.98c0-1.08,0.58-2.03,1.44-2.55c2.41-1.63,4.48-3.25,6.21-4.85 c1.72-1.59,3.16-3.22,4.32-4.9c0.03-0.05,0.07-0.1,0.11-0.14c1.12-1.64,2.08-3.31,2.87-5.01c0.81-1.73,1.46-3.51,1.94-5.34 c0.01-0.04,0.02-0.08,0.03-0.11c0.46-1.78,0.81-3.66,1.05-5.63c0.24-1.98,0.37-4.03,0.37-6.14v-14.1c0-2.27,0.2-4.52,0.61-6.77 c0.41-2.24,1-4.39,1.79-6.44c0.78-2.05,1.72-4.02,2.81-5.9c2.2-3.8,4.93-7.09,8.27-9.94c1.63-1.39,3.39-2.66,5.28-3.79 c1.91-1.14,3.89-2.1,5.93-2.88c1.42-0.54,2.89-0.99,4.39-1.36c0.51-1.79,1.39-3.24,2.64-4.35c1.72-1.53,3.98-2.29,6.79-2.26 c2.78,0.02,5.03,0.79,6.73,2.32C70.98,11.56,63.5,8.62,71.91,11.94L71.91,11.94z"
                    />
                  </g>
                </svg>
                در صورت موجود شدن به من اطلاع بده
              </button>
              <div v-else>
                <span>در صورت موجود شدن به شما اطلاع داده میشود</span>
                <button
                  @click="unlistenRequet"
                  :disabled="listenDisabled"
                  class="btn btn-danger mr-2 cancel-listen-btn"
                >
                  لغو
                </button>
              </div>
            </div>
          </template> -->
        </div>
        <div v-else class="text-right mt-3" style="width: 200px">
          <b-skeleton width="100%"></b-skeleton>
        </div>
        <div
          class="product-details-share d-flex justify-content-around mt-2 flex-shrink-0 d-md-none d-block"
        >
          <ProductFavorite
            :productId="product ? product.id : null"
            class="mr-2"
          />
          <ProductShare :product="product" />
        </div>
      </div>
      <div
        v-if="product && !product.isPreview && product.getColors().length"
        :style="isAvailable ? '' : 'opacity: 0.5'"
        class="product-details-color-choose pt-3 text-right"
      >
        <ProductColors v-model="product" />
      </div>
      <div class="attributes-container">
        <ProductSizeChart
          v-if="
            shouldShowSizeChartModal &&
            product != null &&
            product.size_charts != ''
          "
          :sizeChart="product.size_charts"
        />
        <ProductAttributes
          :style="isAvailable ? '' : 'opacity: 0.7'"
          v-if="product"
          v-model="product"
        />
      </div>
      <div id="productHandler" v-if="product">
        <div class="quantity-container">
          <template v-if="isAvailable">
            <span>تعداد : </span>
            <ProductSelectQuantity v-model="product" />
          </template>
          <template v-else>
            <!--    ناموجود      -->
          </template>
        </div>
        <button
          @click="addToCart()"
          :disabled="disabled || !isAvailable"
          class="product-details-cart-btn border-radius15 text-center mt-3 py-sm-2 bg-color-theme"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#fff"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.1213 11.2331H16.8891C17.3088 11.2331 17.6386 10.8861 17.6386 10.4677C17.6386 10.0391 17.3088 9.70236 16.8891 9.70236H14.1213C13.7016 9.70236 13.3719 10.0391 13.3719 10.4677C13.3719 10.8861 13.7016 11.2331 14.1213 11.2331ZM20.1766 5.92749C20.7861 5.92749 21.1858 6.1418 21.5855 6.61123C21.9852 7.08067 22.0551 7.7542 21.9652 8.36549L21.0159 15.06C20.8361 16.3469 19.7569 17.2949 18.4879 17.2949H7.58639C6.25742 17.2949 5.15828 16.255 5.04837 14.908L4.12908 3.7834L2.62026 3.51807C2.22057 3.44664 1.94079 3.04864 2.01073 2.64043C2.08068 2.22305 2.47038 1.94649 2.88006 2.00874L5.2632 2.3751C5.60293 2.43735 5.85274 2.72207 5.88272 3.06905L6.07257 5.35499C6.10254 5.68257 6.36234 5.92749 6.68209 5.92749H20.1766ZM7.42631 18.9079C6.58697 18.9079 5.9075 19.6018 5.9075 20.459C5.9075 21.3061 6.58697 22 7.42631 22C8.25567 22 8.93514 21.3061 8.93514 20.459C8.93514 19.6018 8.25567 18.9079 7.42631 18.9079ZM18.6676 18.9079C17.8282 18.9079 17.1487 19.6018 17.1487 20.459C17.1487 21.3061 17.8282 22 18.6676 22C19.4969 22 20.1764 21.3061 20.1764 20.459C20.1764 19.6018 19.4969 18.9079 18.6676 18.9079Z"
            />
          </svg>
          <span class="text-white fontsize15 mr-2">{{
            !this.product || isAvailable ? "افزودن به سبد خرید" : "بزودی"
          }}</span>
        </button>
      </div>
      <div class="mt-3" v-else>
        <b-skeleton width="100px" height="60px" />
        <b-skeleton width="210px" height="55px" style="margin-top: 10px" />
      </div>
      <p
        class="mt-3 text-success"
        v-if="product && selectedVariety && alreadyExistedCart"
      >
        <!--        <svg class="notice-icon" fill="#28a745" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 122.88 122.881" enable-background="new 0 0 122.88 122.881" xml:space="preserve"><g><path d="M57.454,89.262c-0.212-0.51-0.319-1.059-0.319-1.645c0-0.588,0.106-1.137,0.319-1.646c0.21-0.506,0.526-0.969,0.945-1.389 h0L58.4,84.58h0c0.419-0.42,0.883-0.734,1.39-0.945c0.51-0.213,1.06-0.318,1.646-0.318c0.591,0,1.142,0.105,1.652,0.318 c0.5,0.207,0.957,0.516,1.371,0.924c0.008,0.008,0.016,0.014,0.022,0.021c0.419,0.418,0.734,0.883,0.945,1.391 c0.213,0.51,0.318,1.059,0.318,1.646c0,0.586-0.105,1.135-0.318,1.645c-0.211,0.506-0.525,0.971-0.945,1.391 c-0.421,0.42-0.888,0.74-1.398,0.953c-0.509,0.213-1.059,0.32-1.647,0.32c-0.586,0-1.134-0.107-1.642-0.32 c-0.498-0.209-0.957-0.52-1.371-0.93c-0.008-0.008-0.016-0.016-0.024-0.023C57.98,90.234,57.665,89.77,57.454,89.262L57.454,89.262 z M61.44,5.165c-3.894,0-7.67,0.366-11.326,1.098c-3.661,0.732-7.193,1.825-10.592,3.277l0.001,0.004 c-3.455,1.486-6.672,3.224-9.646,5.22c-2.98,2-5.744,4.271-8.284,6.821l-0.01,0.01h0c-2.55,2.541-4.821,5.303-6.821,8.284 c-1.996,2.974-3.733,6.191-5.22,9.646c-0.018,0.042-0.037,0.082-0.056,0.123c-1.426,3.361-2.501,6.852-3.225,10.468 c-0.732,3.656-1.098,7.432-1.098,11.325c0,3.895,0.366,7.67,1.098,11.326c0.732,3.66,1.825,7.193,3.277,10.592l0.003-0.002 c1.486,3.455,3.224,6.672,5.22,9.646c2,2.98,4.271,5.744,6.821,8.283l0.01,0.01l0,0c2.54,2.551,5.303,4.822,8.284,6.822 c2.974,1.994,6.191,3.732,9.646,5.219c0.042,0.018,0.083,0.037,0.123,0.057c3.361,1.426,6.852,2.5,10.468,3.225 c3.656,0.732,7.432,1.098,11.326,1.098s7.67-0.365,11.325-1.098c3.661-0.732,7.192-1.826,10.593-3.277l-0.002-0.004 c3.455-1.486,6.672-3.225,9.646-5.219c2.979-2,5.743-4.271,8.283-6.822l0.01-0.01l0,0c2.549-2.539,4.821-5.303,6.82-8.283 c1.996-2.975,3.734-6.191,5.221-9.646c0.018-0.041,0.036-0.082,0.056-0.121c1.427-3.361,2.501-6.854,3.225-10.469 c0.732-3.656,1.099-7.432,1.099-11.326c0-3.893-0.366-7.669-1.099-11.325c-0.732-3.661-1.825-7.192-3.277-10.592l-0.003,0.001 c-1.486-3.455-3.225-6.672-5.221-9.646c-1.999-2.98-4.271-5.743-6.82-8.284l-0.01-0.01l0,0c-2.54-2.549-5.304-4.821-8.283-6.821 c-2.975-1.996-6.191-3.734-9.646-5.22c-0.041-0.018-0.082-0.037-0.123-0.056c-3.361-1.426-6.852-2.501-10.468-3.225 C69.11,5.531,65.334,5.165,61.44,5.165L61.44,5.165z M49.106,1.199C53.098,0.4,57.21,0,61.44,0c4.229,0,8.342,0.4,12.334,1.199 c3.936,0.788,7.764,1.971,11.48,3.549c0.047,0.017,0.093,0.035,0.14,0.055c3.705,1.594,7.198,3.486,10.473,5.684 c3.265,2.191,6.286,4.674,9.061,7.457l0.01,0.01c2.782,2.774,5.266,5.796,7.456,9.061c2.198,3.274,4.09,6.767,5.684,10.473 l-0.003,0.001l0.003,0.009c1.606,3.757,2.808,7.628,3.604,11.609c0.799,3.992,1.198,8.104,1.198,12.334 c0,4.23-0.399,8.344-1.198,12.334c-0.788,3.936-1.971,7.764-3.549,11.48c-0.017,0.047-0.035,0.094-0.056,0.141 c-1.594,3.705-3.485,7.197-5.684,10.473c-2.19,3.264-4.674,6.285-7.456,9.061l-0.01,0.01c-2.774,2.783-5.796,5.266-9.061,7.457 c-3.274,2.197-6.768,4.09-10.473,5.684l-0.002-0.004l-0.009,0.004c-3.757,1.605-7.628,2.807-11.609,3.604 c-3.992,0.799-8.104,1.199-12.334,1.199c-4.23,0-8.343-0.4-12.334-1.199c-3.935-0.789-7.763-1.971-11.48-3.549 c-0.047-0.018-0.093-0.035-0.14-0.055c-3.706-1.594-7.198-3.486-10.473-5.684c-3.264-2.191-6.286-4.674-9.06-7.457l-0.01-0.01 c-2.783-2.775-5.266-5.797-7.457-9.061c-2.198-3.275-4.09-6.768-5.684-10.473l0.004-0.002l-0.004-0.01 c-1.605-3.756-2.807-7.627-3.604-11.609C0.4,69.783,0,65.67,0,61.439c0-4.229,0.4-8.342,1.199-12.334 c0.788-3.935,1.971-7.763,3.548-11.479c0.017-0.047,0.036-0.093,0.055-0.14c1.594-3.706,3.486-7.199,5.684-10.473 c2.19-3.264,4.674-6.286,7.457-9.061l0.01-0.01c2.774-2.783,5.796-5.266,9.06-7.457c3.275-2.198,6.768-4.09,10.473-5.684 l0.002,0.003l0.008-0.003C41.254,3.197,45.125,1.996,49.106,1.199L49.106,1.199z M64.107,77.82 c-0.005,1.012-0.717,1.65-1.627,1.924c-0.331,0.1-0.687,0.148-1.04,0.148s-0.709-0.049-1.04-0.148 c-0.91-0.273-1.622-0.912-1.627-1.924l-3.417-44.679c-0.001-0.01-0.001-0.021-0.001-0.031h-0.001c0-1.094,1.63-1.758,3.715-2.018 c0.75-0.093,1.561-0.14,2.371-0.14s1.621,0.047,2.37,0.14c2.086,0.26,3.716,0.924,3.716,2.018c0,0.018-0.002,0.036-0.004,0.053 L64.107,77.82L64.107,77.82z"/></g></svg>-->
        <svg
          class="notice-icon"
          fill="#28a745"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="20px"
          height="20px"
          viewBox="0 0 122.88 122.88"
          enable-background="new 0 0 122.88 122.88"
          xml:space="preserve"
        >
          <g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M61.44,0c33.926,0,61.44,27.514,61.44,61.44c0,33.926-27.514,61.439-61.44,61.439 C27.513,122.88,0,95.366,0,61.44C0,27.514,27.513,0,61.44,0L61.44,0z M52.687,90.555H69.44v14.81H52.687V90.555L52.687,90.555z M69.431,82.96H52.691c-1.665-20.343-5.159-29.414-5.159-49.729c0-7.492,6.075-13.57,13.567-13.57s13.57,6.078,13.57,13.57 C74.67,53.535,71.13,62.633,69.431,82.96L69.431,82.96z"
            />
          </g>
        </svg>
        <span
          >{{ alreadyExistedCart.quantity }} عدد از این محصول در سبد خرید شما
          وجود دارد</span
        >
      </p>
      <p class="freeShipping-text">
        در فاکتور های بالای بیست میلیون هزینه ارسال را مجموعه پرداخت میکند
        همچنین هزینه مرجوع کردنه محصول و ارسال برای ما به پای مشتری میباشد
      </p>
    </section>

    <ProductCongratulations
      v-if="showCongratulations"
      v-model="showCongratulations"
    />
  </section>
</template>
<script>
import Galleries from "@/parts/Front/components/productDetail/ProductGalleries";
import ProductAttributes from "@/parts/Front/components/productDetail/ProductAttributes";
import ProductColors from "@/parts/Front/components/productDetail/ProductColors";
import ProductSelectQuantity from "@/parts/Front/components/productDetail/ProductSelectQuantity";
import ProductFavorite from "@/parts/Front/components/productDetail/ProductFavorite";
import ProductCongratulations from "@/parts/Front/components/productDetail/ProductCongratulations";
import FlipCountdown from "vue2-flip-countdown";
import ProductShare from "@/parts/Front/components/productDetail/ProductShare";
import ProductSizeChart from "@/parts/Front/components/productDetail/ProductSizeChart";
import { BSkeleton } from "bootstrap-vue";
import { cartListsOpen } from "@/libraries/functions";
export default {
  props: {
    value: Object || null,
    sets: {
      type: Array,
      required: false,
    },
  },
  components: {
    ProductShare,
    ProductCongratulations,
    ProductSelectQuantity,
    ProductColors,
    ProductAttributes,
    Galleries,
    ProductFavorite,
    ProductSizeChart,
    BSkeleton,
    FlipCountdown,
  },
  inject: ["mediaQueries"],
  data() {
    return {
      product: this.value,
      disabled: false,
      listenDisabled: false,
      showCongratulations: false,
      images: [],
      labels: {
        days: "روز",
        hours: "ساعت",
        minutes: "دقیقه",
        seconds: "ثانیه",
      },
    };
  },
  watch: {
    value(newVal) {
      this.product = newVal;
      // this.selectFirstIfNotSelected()
    },
    product(newVal) {
      this.$emit("input", newVal);
    },

    selectedVariety(nv) {
      if (nv) {
        this.getOrginalImagesFromVaritey(nv.id);
      }
    },
  },
  computed: {
    shouldShowSizeChartModal() {
      return this.product && this.product.size_charts != "";
    },
    isMobile() {
      return this.mediaQueries.mobileSize;
    },
    prices() {
      return this.product.getMainPrices();
    },
    selectedVariety() {
      if (!this.product || this.product.isPreview) {
        return null;
      }
      return this.product.getSelectedVariety();
    },
    selectedVarietyForGallery() {
      if (!this.product) {
        return null;
      } else if (this.product && !this.product.isPreview) {
        return this.product.getSelectedVariety(["size"]);
      }
    },
    isAvailable() {
      // آیا قابل خرید هست اصلا
      // حتی اگر یک تنوعش قابل خرید باشه هست
      return (
        this.product &&
        !this.product.isPreview &&
        this.product.status === "available" &&
        this.hasQuantity
      );
    },
    hasQuantity() {
      return this.product && this.product.getMaxQuantity() > 0;
    },
    alreadyExistedCart() {
      // اگر تنوع انتخاب شده توی سبد وجود داشت بهمون میده
      if (!this.selectedVariety || !this.$store.getters["front/getHomeData"]) {
        return null;
      }
      return this.$store.getters["front/getHomeData"].user.cart.hasVariety(
        this.selectedVariety,
      );
    },

    // عکس های محصول و تنوع رو هم
    galleries: {
      get() {
        if (!this.value) {
          return [];
        }
        if (this.images.length) {
          return this.images;
        }

        // تجمیع همه عکس های محصول شامل خود محصول و تنوع ها
        this.images = [];
        this.value.images.forEach((img) => {
          img.variety_id = null;
          this.images.push(img);
        });
        if (this.value.isPreview) {
          return this.images;
        }
        // اگر میخواهید تنوع ها در ابتدا نمایش داده نشوند فورایچ زیر را کامنت کنید
        this.value.varieties.forEach((variety) => {
          variety.images.forEach((img) => {
            img.variety_id = variety.id;
            this.images.push(img);
          });
        });
        return this.images;
      },
      set(newVariety) {
        if (newVariety) {
          let images = [];
          newVariety.images.forEach((img) => {
            img.variety_id = newVariety.id;
            images.push(img);
          });
          this.images = images;
        }
      },
    },
    hasInListens() {
      let homeData = this.$store.getters["front/getHomeData"];
      if (!homeData) {
        return false;
      }
      let user = homeData.user.user;
      if (!user) {
        return false;
      }

      return user.listen_charges.find((listenCharge) => {
        return listenCharge.product_id == this.product.id;
      });
    },
  },
  mounted() {},
  methods: {
    getOrginalImagesFromVaritey(variety_id) {
      let unit = this.product.varieties[0].color
        ? "color"
        : this.product.varieties[0].attributes.length == 2
        ? "طرح"
        : this.product.varieties[0].attributes[0].name;

      let findedVariety = this.product.varieties.find((varitey) => {
        if (varitey.id == variety_id) return varitey;
      });

      if (findedVariety && findedVariety.images.length) {
        this.galleries = findedVariety;
      } else {
        if (unit == "color") {
          let baseColor = findedVariety.color_id;
          let findedReplaceVariety = this.product.varieties.find((variety) => {
            if (variety.color_id == baseColor && variety.images.length) {
              return variety;
            }
          });
          this.galleries = findedReplaceVariety;
        } else {
          let findedAttr = findedVariety.attributes.find((attr) => {
            return attr.name == unit;
          });

          let findedReplaceVariety = this.product.varieties.find((variety) => {
            let findFlag = false;
            variety.attributes.forEach((attribute) => {
              if (
                attribute.name == unit &&
                findedAttr.pivot.value == attribute.pivot.value &&
                variety.images.length
              ) {
                findFlag = true;
              }
            });
            if (findFlag) {
              return variety;
            }
          });
          this.galleries = findedReplaceVariety;
        }
      }
    },
    selectFirstIfNotSelected() {
      this.product.selectFirstIfNotSelected();
    },
    async addToCart() {
      this.disabled = true;
      try {
        const response = await this.product.addToCart();
        cartListsOpen();
        // felan barmidaram ta bebinam dastane responsivesh chetorie
        if (this.isMobile) {
          this.showCongratulations = true;
        } else {
          this.$root.notify(response.data.message, "success");
        }
      } catch (error) {
        if (error.message === "SELECT-VARIETY") {
          this.$root.debouncedNotify(
            "لطفا گزینه های محصول را انتخاب کنید",
            "warning",
          );
          let scrollDiv = document.querySelector(
            ".attributes-container",
          ).offsetTop;
          window.scrollTo({ top: scrollDiv - 100, behavior: "smooth" });
        } else if (error.message === "SELECT-QUANTITY") {
          this.$root.debouncedNotify("لطفا تعداد را انتخاب کنید", "warning");
        } else if (error.message === "NO_STOCK") {
          // This error may happen if cart is in "cookie" mode
          this.$root.errorNotify("موجودی محصول کافی نیست");
        } else {
          this.$root.notify(error);
        }
      } finally {
        this.disabled = false;
      }
    },
    // آیا این کاربر قبلا برای مطلع شدن از موجود شدن این محصول اقدام کرده
    async listenRequest() {
      let homeData = this.$store.getters["front/getHomeData"];
      if (!homeData.user.user) {
        window.$("#loginModal").modal("show");
        return;
      }
      try {
        this.listenDisabled = true;
        const response = await this.$axios.post(
          `customer/products/${this.product.id}/listen`,
        );
        homeData.user.user.listen_charges.push(response.data.data.listenCharge);
        this.$root.notify(response, "success");
      } catch (error) {
        this.$root.notify(error);
      }
      this.listenDisabled = false;
    },
    async unlistenRequet() {
      let homeData = this.$store.getters["front/getHomeData"];
      try {
        this.listenDisabled = true;
        const response = await this.$axios.delete(
          `customer/products/${this.product.id}/unlisten`,
        );
        homeData.user.user.listen_charges =
          homeData.user.user.listen_charges.filter((listenCharge) => {
            return listenCharge.product_id != this.product.id;
          });
        this.$root.notify(response, "success");
      } catch (error) {
        this.$root.notify(error);
      }
      this.listenDisabled = false;
    },
  },
};
</script>
<style scoped>
.ProductContent {
  padding-top: 2rem;
}
.product-details {
  width: 80%;
  margin: auto;
  border-radius: 20px;
  background-color: #fff;
}
@media screen and (max-width: 1200px) {
  .product-details {
    width: 93%;
  }
}
.quantity-container {
  margin-top: 10px;
  max-width: 85px;
}
.notice-icon {
  margin-left: 4px;
  transform: translateY(-3px);
  opacity: 0.7;
}
.cancel-listen-btn {
  padding: 2px 11px;
  font-size: 14px;
}

.text-red {
  color: var(--color-themeRed);
}

.price {
  display: flex;
  gap: 15px;
}

.product-details-color-choose {
  overflow-x: auto;
}
.freeShipping-text {
  padding: 10px;
  background-color: var(--color-theme-main);
  font-size: 16px;
  color: white;
  position: absolute;
  left: 5%;
  top: 53%;
  max-width: 400px;
  text-align: justify;
}

@media screen and (max-width: 1690px) {
  .product-details-color-choose {
    margin-right: -14px;
  }
  .freeShipping-text {
    margin-top: 10px;
    position: unset;
    max-width: 528px;
  }
}
@media screen and (max-width: 1050px) {
  .freeShipping-text {
    margin-top: 10px;
    position: unset;
    max-width: 450px;
  }
}
.product-details-color-choose::-webkit-scrollbar {
  height: 7px;
  background-color: var(--color-theme2);
}
.product-details-color-choose::-webkit-scrollbar-thumb {
  height: 7px;
  background-color: var(--color-theme);
}
.product-details-color-choose::-webkit-scrollbar-track {
  background-color: var(--color-theme2);
}
div#productHandler {
  display: flex;
  flex-direction: column;
}
</style>
<style>
div#productDiscountCountdown .flip-clock {
  direction: ltr;
}
div#productDiscountCountdown .flip-card__top,
div#productDiscountCountdown .flip-card__bottom,
div#productDiscountCountdown .flip-card__back-bottom,
div#productDiscountCountdown .flip-card__back::before,
div#productDiscountCountdown .flip-card__back::after {
  background: var(--color-theme-main);
  border-top: 1px solid var(--color-theme-main);
}
@media (max-width: 768px) {
  .wrapMobile {
    flex-wrap: wrap;
  }
}
</style>
